import { isAxiosError } from "axios";
import { AnnieRequestError } from "../utils/annieStream";

/**
 * Pulls the HTTP status + UIVisibleError i18n key out of a failed Annie call.
 *
 * `detailKey`/`detailParams` are the backend's own more specific explanation, carried locale-neutrally
 * (the same shape a preflight item uses). Preferred over the generic `key` when present, so the reason
 * the head nurse reads is both specific AND translated. Only some errors attach one.
 */
export const extractAnnieError = (error: unknown): { status?: number; key?: string; detailKey?: string; detailParams?: Record<string, string> } => {
	if (error instanceof AnnieRequestError) return { status: error.status, key: error.messageKey };
	if (isAxiosError<{ detail?: { message?: string; details?: { detail_key?: unknown; detail_params?: unknown } } | string }>(error)) {
		const detail = error.response?.data?.detail;
		if (typeof detail !== "object") return { status: error.response?.status };
		// `details` is free-form backend context, so both halves are shape-checked before use.
		const rawKey = detail?.details?.detail_key;
		const rawParams = detail?.details?.detail_params;
		return {
			status: error.response?.status,
			key: detail?.message,
			detailKey: typeof rawKey === "string" ? rawKey : undefined,
			detailParams: rawParams !== null && typeof rawParams === "object" ? (rawParams as Record<string, string>) : undefined,
		};
	}
	// DEFAULT: network/runtime errors without an HTTP response have neither field; callers still surface a generic translated error.
	return {};
};
